import React, { useState } from "react";
import DatePicker from "react-datepicker";
import * as Yup from 'yup';
import { Formik } from 'formik';
import toast, { Toaster } from "react-hot-toast";

import "react-datepicker/dist/react-datepicker.css";
import useScriptRef from "../hooks/useScriptRef";
import useApi from "../hooks/useApi";
import './P2POpen.css';
import { useDispatch, useSelector } from "../store";
import { ChangePage } from "../store/reducers/menu";

export default function P2POpenCard() {
    const scriptedRef = useScriptRef();
    const { currency } = useSelector((store) => store.auth);
    const dispatch = useDispatch();
    const { createPool, getPools } = useApi();

    const create = async (values, { setErrors, setStatus, setSubmitting }) => {
        if (currency.symbol !== 'USDT') {
            toast.error('You have to choose USDT!')
        } else {
            const data = {
                content: values.content,
                option: { 1: values.option1, 2: values.option2 },
                min: values.min,
                max: values.max,
                expire: String(new Date(values.expire).getTime())
            }
            try {
                await createPool(data)
                    .then(
                        ({ data }) => {
                            toast.success('You created successfully!')
                            getPools()
                            dispatch(ChangePage(""))
                        },
                        (err) => {
                            if (scriptedRef.current) {
                                setStatus({ success: false });
                                setErrors({ submit: err.message });
                                setSubmitting(false);
                            }
                        }
                    )
                    .catch((error) => {
                        console.log(error)
                    });
            } catch (err) {
                if (scriptedRef.current) {
                    setStatus({ success: false });
                    setErrors({ submit: err.message });
                    setSubmitting(false);
                }
            }
        }
    };
    return (
        <Formik
            initialValues={{
                content: '',
                option1: '',
                option2: '',
                min: 10,
                max: 20,
                expire: new Date(),
                submit: null
            }}
            validationSchema={Yup.object().shape({
                content: Yup.string()
                    .min(1)
                    .max(255)
                    .required('Pool Title is required'),
                option1: Yup.string()
                    .min(1)
                    .max(255)
                    .required('First Option is required'),
                option2: Yup.string()
                    .min(1)
                    .max(255)
                    .required('Second Option is required'),
                min: Yup.string()
                    .min(1)
                    .required('Min Amount is required'),
                max: Yup.number()
                    .min(Yup.ref('min'), 'Max Amount must be greater than Min Amount')
                    .required('Max Amount is required'),
                expire: Yup.date()
                    .min(new Date(), 'Selected date must be later than the current date')
                    .required('Date is required'),
            })}
            onSubmit={create}>
            {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, setFieldValue, touched, values }) => (
                <form className="space-y-6" noValidate onSubmit={handleSubmit} >
                    <div
                        style={{ marginTop: "0px" }}
                        className="bg-bcb_sidebar pt-4 p-8 rounded-md"
                    >
                        <p className="text-sm text-white text-center mb-4">Open Round</p>
                        <div
                            style={{ marginTop: "0.5rem" }}
                            className="bg-background p-4 rounded-md"
                        >
                            <p className="text-xs text-gray-500 mb-2">Pool Title</p>
                            <div className="flex items-start justify-start flex-row space-x-4 ">
                                <img
                                    src="https://icodrops.com/wp-content/uploads/2018/10/Ethereum-Logo.png"
                                    alt="eth"
                                    style={{ height: "2.5rem" }}
                                    className="rounded-lg object-contain"
                                />
                                <input
                                    name="content"
                                    id="content"
                                    className="bg-background block w-full text-sm focus:outline-none dark:text-gray-300 leading-5 rounded-md focus:border-yellow-300 outline-none"
                                    type="text"
                                    placeholder={"Is ETH going over 4K by February?"}
                                    value={values.content}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                            </div>
                            {touched.content && errors.content && (
                                <h4 className="text-sm font-medium text-red-400">
                                    {errors.content}
                                </h4>
                            )}
                        </div>
                        <div
                            style={{ marginTop: "0.5rem" }}
                            className=" bg-background rounded-md p-2"
                        >
                            <div>
                                <p className="text-xs text-gray-500 mb-2 ">Option 1</p>
                                <input
                                    name="option1"
                                    id="option1"
                                    className="bg-background block w-full text-sm focus:outline-none dark:text-gray-300 leading-5 rounded-md focus:border-yellow-300 outline-none"
                                    type="text"
                                    placeholder={"Yes"}
                                    value={values.option1}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {touched.option1 && errors.option1 && (
                                    <h4 className="text-sm font-medium text-red-400">
                                        {errors.option1}
                                    </h4>
                                )}
                            </div>
                            <div className="mt-2">
                                <p className="text-xs text-gray-500 mb-2 ">Option 2</p>
                                <input
                                    name="option2"
                                    id="option2"
                                    className="bg-background block w-full text-sm focus:outline-none dark:text-gray-300 leading-5 rounded-md focus:border-yellow-300 outline-none"
                                    type="text"
                                    placeholder={"No"}
                                    value={values.option2}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {touched.option2 && errors.option2 && (
                                    <h4 className="text-sm font-medium text-red-400">
                                        {errors.option2}
                                    </h4>
                                )}
                            </div>
                        </div>
                        <div
                            style={{ marginTop: "0.5rem" }}
                            className="bg-background rounded-md p-2"
                        >
                            <p className="text-xs text-gray-500 mb-2 ">Expire Time</p>
                            <DatePicker
                                name="expire"
                                id="expire"
                                className="bg-background text-white p-2 rounded"
                                selected={values.expire}
                                onChange={(date) => setFieldValue('expire', date)}
                                onBlur={handleBlur}
                            />
                            {touched.expire && errors.expire && (
                                <h4 className="text-sm font-medium text-red-400">
                                    {errors.expire}
                                </h4>
                            )}
                        </div>
                        <div
                            style={{ marginTop: "0.5rem" }}
                            className="bg-background rounded-md p-2"
                        >
                            <div className="flex items-start justify-start flex-row space-x-4">
                                <div>
                                    <p className="text-xs text-gray-500 mb-2 ">Min Amount USDT</p>
                                    <input
                                        name="min"
                                        id="min"
                                        type="number"
                                        placeholder="5000"
                                        className="w-full text-white bg-stone-1000border border-stroke dark:border-stone-1000 py-[10px] pr-3 pl-5 text-dark-6 outline-none transition  border-r-0 disabled:cursor-default disabled:bg-gray-2 focus:border-primary dark:focus:ring-stone1000 dark:bg-stone-1000"
                                        value={values.min}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    />
                                    {touched.min && errors.min && (
                                        <h4 className="text-sm font-medium text-red-400">
                                            {errors.min}
                                        </h4>
                                    )}
                                </div>
                                <div>
                                    <p className="text-xs text-gray-500 mb-2 ">Max Amount USDT</p>
                                    <input
                                        name="max"
                                        id="max"
                                        type="number"
                                        placeholder="5000"
                                        className="w-full text-white bg-stone-1000border border-stroke dark:border-stone-1000 py-[10px] pr-3 pl-5 text-dark-6 outline-none transition  border-r-0 disabled:cursor-default disabled:bg-gray-2 focus:border-primary dark:focus:ring-stone1000 dark:bg-stone-1000"
                                        value={values.max}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    />
                                    {touched.max && errors.max && (
                                        <h4 className="text-sm font-medium text-red-400">
                                            {errors.max}
                                        </h4>
                                    )}
                                </div>
                            </div>
                        </div>
                        <button
                            disableElevation
                            disabled={isSubmitting}
                            type="submit"
                            className="w-full text-white bg-yellow-400 hover:bg-yellow-600 focus:ring-4 focus:outline-none focus:ring-yellow-300 font-medium rounded-lg text-sm mt-2 px-5 py-2.5 text-center dark:bg-yellow-400 dark:hover:bg-yellow-600 dark:focus:ring-yellow-800"
                        >
                            Create
                        </button>
                    </div>
                </form>
            )}
        </Formik>
    )
}
